/**
 * Each step is `flex-1 w-full` before it caps, so a control shrinks with its column — the cards
 * lay out two-up above `lg`, where a fixed pixel width would overflow. Reach for `full` when the
 * control should simply take the column (NAICS chips, yes/no pairs, textareas).
 */
const FIELD_WIDTHS = {
	/** Money, counts, dates — anything whose content is a handful of characters. */
	sm: "max-w-[200px]",
	/** Multi-selects and dropdowns whose summary text runs long. */
	md: "max-w-[300px]",
	/** Free text on one line, e.g. project name. */
	lg: "max-w-[400px]",
	/** No cap — the control fills whatever column it lands in. */
	full: "",
} as const;

export type ViewSectionFieldSize = keyof typeof FIELD_WIDTHS;

/** Width classes for a `ViewSectionCardEditItem`'s edit/view slot at the given step. */
export const viewSectionFieldWidth = (size: ViewSectionFieldSize = "full") =>
	`flex-1 w-full justify-end ${FIELD_WIDTHS[size]}`.trim();
